import type { CartLine, CartLineDraft } from "./types";

/**
 * Two cart lines are considered the same booking when they share
 * (experience, package, date, time). Travelers/price are mutable details of
 * one booking, not identity. Adding "the same Standard package on Dec 5 at
 * 9 AM" twice should update the existing line, not create a duplicate.
 */
function dedupKey(input: CartLine | CartLineDraft): string {
  const dateOnly = input.date.slice(0, 10);
  const time = input.time ?? "__date_only__";
  return `${input.experienceSlug}::${input.packageId}::${dateOnly}::${time}`;
}

export function findLineByDedup(
  lines: readonly CartLine[],
  draft: CartLineDraft,
): CartLine | undefined {
  const key = dedupKey(draft);
  return lines.find((line) => dedupKey(line) === key);
}
